import React, { ReactElement } from "react"

import { useDataModaUploadContext } from "../../../providers/DataModaUploadContext"
import { requiredFields } from "../../../constants/prices"

const SelectedFields = (): ReactElement => {
  const { selectedOptions } = useDataModaUploadContext()
  const listOfOptions = selectedOptions?.filter(item => item.selected === true).map(i => i.type)

  const checkField = (field: string): boolean => {
    return Array.isArray(listOfOptions) ? listOfOptions.includes(field) : false
  }

  return (
    <div className="flex flex-wrap gap-2 bg-white justify-center items-center p-2 border-t-2 border-gray-200 sticky bottom-0">
      {requiredFields.map(item => (
        <div
          key={item.field}
          title="Mandatory field"
          className={`inline-flex items-center rounded-md p-1 px-2 text-xs font-bold border-2 border-solid ${
            checkField(item.field) ? "bg-green-400/10 text-teal-500" : "bg-red-400/10 text-red-400"
          }  `}
        >
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  )
}

export default SelectedFields
